<template>
  <DefaultLayout>
    <template #buttons>
      <ProviderCreateAction @created="reload" v-if="can('PROVIDER_MANAGE')" />
    </template>

    <ProviderFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Providers') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ providers.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
      </template>
    </ProviderFilter>

    <ProviderList :pagination="pagination" :providers="providers" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import ProviderCreateAction from "@/components/provider/ProviderCreateAction.vue";
import ProviderFilter from "@/components/provider/ProviderFilter.vue";
import ProviderList from "@/components/provider/ProviderList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    ProviderCreateAction,
    ProviderFilter,
    ProviderList,
  },
  data() {
    return {
      listPropertyName: 'providers',
      apiResource: `providers`,
      providers: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Providers'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'provider';
    },
  },
};
</script>